import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "28",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "#fff",
      "data-figma-bg-blur-radius": "43.492"
    }, [
      _createElementVNode("rect", {
        width: "28",
        height: "28",
        "fill-opacity": ".2",
        rx: "14"
      }),
      _createElementVNode("path", { d: "M17.48 9.106a1 1 0 1 1 1.414 1.414L15.414 14l3.48 3.48a1 1 0 1 1-1.414 1.414l-3.481-3.48-3.48 3.48a1 1 0 1 1-1.414-1.414l3.48-3.48-3.48-3.48a1 1 0 0 1 1.415-1.414l3.479 3.48z" })
    ], -1)
  ])))
}
export default { render: render }